module.exports = __webpack_public_path__ + "img/create-simulation.a1f49de1.png";